/**
 * REGISTRE DES ÉCRANS CUSTOM — les métadonnées seules.
 *
 * Une page de type `custom` ne décrit pas ce qu'elle montre : elle NOMME un
 * composant React, dans `content.component_id`. C'est le même mécanisme que
 * `list_graph: [{component_id, metadata}]` (cf. GraphGrid.js), d'un cran plus
 * haut — la page au lieu de la carte.
 *
 * POURQUOI UN TYPE UNIQUE ET NON UN TYPE PAR ÉCRAN. Un type de page est un
 * enum de fait, éparpillé sur une dizaine de sites (PAGE_TYPES, emptyByType,
 * TABS_BY_TYPE, KNOWN_PAGE_TYPES côté serveur, deux `switch` de rendu…). Un
 * écran custom de plus coûte ici UNE entrée de registre et une ligne dans la
 * table de CustomPage.js.
 *
 * CE FICHIER N'IMPORTE AUCUN COMPOSANT, à dessein. Le builder le lit pour
 * afficher des libellés et des icônes (pageKinds.js, et de là le déroulé, le
 * graphe de l'atelier, la carte des conséquences) : lier les composants ici
 * ferait entrer chart.js, d3 et react-simple-maps dans tout écran qui veut
 * seulement savoir comment s'appelle une page. La liaison vit dans
 * CustomPage.js, au seul endroit qui monte réellement ces écrans.
 *
 * LES DEUX LISTES DOIVENT RESTER D'ACCORD. Une entrée sans composant rend
 * l'écran de repli de CustomPage — visible, jamais silencieux.
 *
 * `requiredScores` vit côté serveur, dans game_validator.CUSTOM_PAGE_SCORES :
 * c'est là qu'un atelier est vérifié. Même dette assumée que
 * CONTEXT_LAYOUT_SLOTS et son homologue Python.
 *
 * CES DEUX ÉCRANS SONT EN SURSIS. Ils sont durcis (métriques, phases et image
 * de fond écrites dans le JSX). Le chemin de sortie passe par `content.metadata`,
 * que le résolveur transmet déjà : chaque valeur qui en sort rapproche la page
 * d'un simple `type: score` avec son `list_graph`, après quoi l'entrée de
 * registre et le composant disparaissent ensemble.
 *
 * LES TROIS ACCEPTENT `content.metadata.extra_sections` (BoardSections.js) : des
 * sections de graphes ajoutées en bas de page, sans écran de plus.
 */
export const CUSTOM_PAGES = [
  {
    id: 'btp_summary',
    label: 'Bilan BTP',
    icon: '🏗️',
    hint: "Bilan de fin d'atelier BTP : tableau de synthèse, CBS, empreinte eau par phase, podium des acteurs.",
  },
  {
    id: 'disney_summary',
    label: 'Bilan Compte-Gouttes (organisation)',
    icon: '💧',
    hint: "Bilan d'un atelier Compte-Gouttes centré sur une organisation (Disney, RATP) : projection des économies d'eau, radar, podium, empreintes de l'organisation. Réglages dans content.metadata (doughnut_scores, selected_metrics, organisation_title, background_image_url), valeurs Disney par défaut.",
  },
  {
    id: 'acg_summary',
    label: 'Bilan Compte-Gouttes',
    icon: '🗳️',
    hint: "Bilan de séance ACG : objectif atteint, classement parmi les autres séances, contraindre/inciter, effort par secteur contre économies réalisées, podium et concessions des acteurs.",
  },
];

/** L'entrée du registre pour un id, ou `undefined`. */
export function customPageById(componentId) {
  return CUSTOM_PAGES.find((entry) => entry.id === componentId);
}

/** L'id du composant nommé par une page custom. */
export function customComponentIdOf(page) {
  return page?.content?.component_id || '';
}
